

exports.__esModule = true;
exports.$AddShippingRoute = undefined;

require('./directive');

var _squid = require('squid');

require('xo-address-components/src/address-normalization/route');

require('xo-address-components/src/add-address/directive');

require('../shipping-address/directive');

var $AddShippingRoute = exports.$AddShippingRoute = _squid.$ComponentRoute.extend('$AddShippingRoute', {
    name: 'addShipping',
    directive: 'xo-add-shipping',
    titleContent: 'addShipping.addAddress',
    trackingData: {
        fptiState: 'add_shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-shipping-address',
                'pagename2': '%::fullpage-add-shipping-address:member:hermes:tray',
                'version': 'member:%:tray'
            }
        }
    },
    loginRequired: true,
    children: [{
        name: '$AddressNormalizationRoute',
        attributes: {
            id: 'token',
            sidebar: 'sidebar',
            address: 'address',
            'done-fn': 'uponNormalization'
        }
    }]
});

angular.value("$AddShippingRoute", $AddShippingRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js
// module id = ../node_modules/xo-member-components/src/select-shipping/add-shipping/route.js
// module chunks = 0